import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';

@Component({
  selector: 'hybse-admin-market-logs',
  templateUrl: './market-logs.component.html',
  styleUrls: ['./market-logs.component.css']
})
export class MarketLogsComponent implements OnInit {

  public type: string;
  public commissonLogs: any[];
  public completeLogs: any[];
  public commissionErrorMessage: string;
  public orderMatchesErrorMessage: string;

  constructor(private _req: ApirequestService,
    private _url: ApiurlsService) { }

  ngOnInit() {
    this.getCommissonLogs();
    this.getOrderMatchesList()
  }

  getCommissonLogs() {
    let url = this._url.commissionLogListUrl;
    this._req.fetchApiData(this._url.commissionLogListUrl, {}).subscribe(
      (data: any) => {
        console.log('commisstion', data);
        if(data){
          let resSucc = data.data;
          let resErr = data.error;
          if (resSucc != '') this.commissonLogs = resSucc.commissionLogList;
          if (resErr != '') this.commissionErrorMessage = resErr.errorDescription;
        }

      },
      error => {

      },
      () => {

      })
  }

  getOrderMatchesList() {
    this._req.fetchApiData(this._url.orderMatchesListUrl, {}).subscribe(
      (data: any) => {
        console.log('Activity logvfghf', data);
        let resSucc = data.data;
        let resErr = data.error;
        if (resSucc != '') {
          this.completeLogs = resSucc.orderMatchesList;
        } else {
          this.orderMatchesErrorMessage = resErr.errorDescription;
        }
      },
      error => {

      },
      () => {

      })
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/markets/logs/market-logs.component.ts